import { Module } from '@nestjs/common';
import { LoanCategoriesController } from './loan-categories.controller';
import { LoanCategoriesService } from './loan-categories.service';
import { TypeOrmModule } from '@nestjs/typeorm';
import { LoanCategoryAdapter } from './dto/loan-categories.adapter';
import { LoanCategory } from './loan-categories.entity';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { LogsService } from '@gtpl/shared-services/user-logs';
@Module({
  imports: [
    TypeOrmModule.forFeature([LoanCategory]),
  ],
  controllers: [LoanCategoriesController],
  providers: [LoanCategoriesService, LoanCategoryAdapter, ApplicationExceptionHandler,LogsService],
  exports: [LoanCategoriesService]
})
export class LoanCategoriesModule {}
